

































import { Vue, Component, Prop } from 'vue-property-decorator'
import { AslistItem } from '@/types/kyc'

@Component({
  name: 'asType'
})
export default class extends Vue {
  @Prop({ required: true }) private data!: AslistItem
  private hoverData = [
    {
      assetTypeId: 'root-asset-0001',
      desTitle: '现金类资产包含：',
      desContent: '活期存款，半年内定期存款，半年内固收类银行理财，货币基金，余额宝类互联网理财等'
    }, {
      assetTypeId: 'root-asset-0003',
      desTitle: '权益类资产包含：',
      desContent: '股票，股票型基金，智能投顾组合，权益类银行理财，权益类信托，权益类券商资管等'
    }, {
      assetTypeId: 'root-asset-0002',
      desTitle: '固收类资产包含：',
      desContent: '半年以上定期存款，半年以上固收类银行理财，固收类信托，债券型基金，政府债，企业债，固收类券商资管，网贷投资，金交所类非标资产，民间借贷等'
    }, {
      assetTypeId: 'root-asset-0004',
      desTitle: '另类资产包含：',
      desContent: '私募股权直投、私募股权基金、不动产投资信托基金（REITs）、对冲基金、贵金属等大宗商品投资、金融衍生品、数字货币，投资性房产，地产基金、艺术品、古董等'
    }
  ]

  private getContent (val: string) {
    const ts = this.hoverData.find((item) => item.assetTypeId === val)
    return ts
  }
}
